module.exports = __webpack_public_path__ + "img/icMale.e2e1e5b1.svg";